export default {
      id: "icon--groups-fixed-usage",
      viewBox: "0 0 32 26.5",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--groups-fixed-usage",
      toString: function () {
        return this.url;
      }
    }